import { Injectable } from "@angular/core";
const cookieBaseUrl = "https://cookielaw.emea.fcagroup.com/CookieLawProduct/resources/generate",
	scriptIDbase = "cookiescript",
	cssIDbase = "css",
	cookies = [
		// { market:"AT", code: 2923 }, TODO: MISSING, TO BE ADDED
		{ market: "FR-BE", code: 2927 },
		{ market: "NL-BE", code: 2926 },
		{ market: "DE", code: 2923 },
		{ market: "EN", code: 2730 },
		{ market: "ES", code: 2916 },
		{ market: "FR", code: 2917 },
		{ market: "IT", code: 2729 },
		{ market: "LU", code: 2917 },
		{ market: "NL", code: 2924 },
		{ market: "PL", code: 2925 },
		{ market: "PT", code: 3725 }
	];

@Injectable()
export class ScriptService {
	private scripts: {
		[key: string]: {
			loaded: boolean;
			src?: string;
			href?: string;
		}
	} = {};
	constructor() {
		for (const item of cookies) {
			this.scripts[`${cssIDbase}${item.market}`] = {
				loaded: false,
				href: `${cookieBaseUrl}css?key=${item.code}`
			};
			this.scripts[`${scriptIDbase}${item.market}`] = {
				loaded: false,
				src: `${cookieBaseUrl}js?key=${item.code}`
			};
		}
	}

	removeScript() {
		return new Promise((/*resolve, reject*/) => {
			for (const item of cookies) {
				const scriptID = `${scriptIDbase}${item.market}`, cssID = `${cssIDbase}${item.market}`
				this.scripts[cssID].loaded = this.scripts[scriptID].loaded = false;
				const script = document.getElementById(scriptID);
				// NOTE: this is useless: removing the script when it's already been parsed doesn't kill it
				if (script) {
					document.head.removeChild(script);
				}
				const css = document.getElementById(cssID);
				if (css) {
					document.head.removeChild(css);
				}
			}
		});
	}

	loadScript(name: string, type: "script" | "css") {
		if (type === "script") {
			name = scriptIDbase + name;
			return new Promise<{ script: string; loaded: boolean; status: string; }>((resolve/* , reject */) => {
				// resolve if already loaded
				if (this.scripts[name].loaded) {
					resolve({ script: name, loaded: true, status: "Already Loaded" });
				} else {
					const script = document.createElement("script");
					script.type = 'text/javascript';
					script.src = this.scripts[name].src;
					script.id = name;

					script.onload = () => {
						this.scripts[name].loaded = true;
						resolve({ script: name, loaded: true, status: "Loaded" });
					};

					script.onerror = (/*error: any*/) => resolve({ script: name, loaded: false, status: "Loaded" });
					// finally append the script tag in the DOM
					document.head.appendChild(script);
				}
			});
		} else {
			name = cssIDbase + name;
			return new Promise<{ script: string; loaded: boolean; status: string; }>((resolve/*, reject*/) => {
				// resolve if already loaded
				if (this.scripts[name].loaded) {
					resolve({ script: name, loaded: true, status: "Already Loaded" });
				} else {
					// load css
					const link = document.createElement("link");
					link.type = "text/css";
					link.href = this.scripts[name].href;
					link.id = name;
					link.rel = "stylesheet";

					link.onload = () => {
						this.scripts[name].loaded = true;
						resolve({ script: name, loaded: true, status: "Loaded" });
					};

					link.onerror = (/*error: any*/) => resolve({ script: name, loaded: false, status: "Loaded" });
					// finally append the script tag in the DOM
					document.head.appendChild(link);
				}
			});
		}
	}
}